// Cosmetic, unambiguous substitutions only: typographic characters that have
// a lossless GSM-7 equivalent. Anything meaningfully non-GSM-7 (emoji,
// non-Latin scripts, accented letters not covered by GSM-7, etc.) is left
// untouched, since replacing it would change what the user wrote.
//
// The whitespace variants are built with String.fromCharCode rather than
// pasted literally: several of them (non-breaking space, narrow no-break
// space, thin space, figure space) are visually identical to a normal space
// and to each other, making it too easy for tooling/editors to silently
// collapse them to a plain U+0020 space.
const SMART_ENCODE_MAP = {
	'‘': "'", // left single quote (U+2018)
	'’': "'", // right single quote (U+2019)
	'‚': "'", // single low quote (U+201A)
	'‛': "'", // single high-reversed quote (U+201B)
	'“': '"', // left double quote (U+201C)
	'”': '"', // right double quote (U+201D)
	'„': '"', // double low quote (U+201E)
	'‟': '"', // double high-reversed quote (U+201F)
	'–': '-', // en dash (U+2013)
	'—': '-', // em dash (U+2014)
	'−': '-', // minus sign (U+2212)
	'…': '...', // ellipsis (U+2026)
	[String.fromCharCode(0x00a0)]: ' ', // non-breaking space
	[String.fromCharCode(0x202f)]: ' ', // narrow non-breaking space
	[String.fromCharCode(0x2009)]: ' ', // thin space
	[String.fromCharCode(0x2007)]: ' ', // figure space
};

export function smartEncodeGsm7(message) {
	if (!message) return message;

	let result = '';
	for (const char of message) {
		result += SMART_ENCODE_MAP[char] ?? char;
	}
	return result;
}
